import React from 'react';
import { useDesign } from '../../designs';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
}

export default function Input({ label, style, ...props }: InputProps) {
  const design = useDesign();
  const d = design.tokens;
  const fs = design.typography.fontSize;

  return (
    <div style={{ marginBottom: '16px' }}>
      <label
        style={{
          display: 'block',
          fontFamily: "'Raleway', sans-serif",
          fontSize: fs.sectionHeader,
          fontWeight: 700,
          letterSpacing: '1.5px',
          textTransform: 'uppercase',
          color: d.textSecondary,
          marginBottom: '6px',
        }}
      >
        {label}
      </label>
      <input
        style={{
          width: '100%',
          padding: '10px 12px',
          fontFamily: "'Raleway', sans-serif",
          fontSize: fs.bodyInput,
          fontWeight: 400,
          color: d.textPrimary,
          backgroundColor: d.bgSurface,
          border: '1px solid rgba(200,146,58,0.10)',
          borderRadius: '2px',
          outline: 'none',
          boxSizing: 'border-box',
          ...style,
        }}
        onFocus={(e) => { e.target.style.borderColor = 'rgba(200,146,58,0.30)'; }}
        onBlur={(e) => { e.target.style.borderColor = 'rgba(200,146,58,0.10)'; }}
        {...props}
      />
    </div>
  );
}
